import { render, staticRenderFns } from "./Shootings.vue?vue&type=template&id=6af56214&scoped=true"
import script from "./Shootings.vue?vue&type=script&lang=js"
export * from "./Shootings.vue?vue&type=script&lang=js"
import style0 from "./Shootings.vue?vue&type=style&index=0&id=6af56214&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6af56214",
  null
  
)

export default component.exports